import { previousRaRef } from './astHelpers';

/** Previous RA field value. */
export const buildPreviousRaFormula = (cfg = {}, selfFieldCode = '') => {
  const code = cfg.previousFieldCode || selfFieldCode;
  if (!code) return null;
  return previousRaRef(code, 0);
};
